import { Button, CircularProgress } from '@mui/material';
import classNames from 'classnames';
import clsx from 'clsx';
import { isEmpty } from 'lodash';
import { observer } from 'mobx-react-lite';
import { useForm } from 'react-hook-form';

import TextField from '../../components/Inputs/TextField';
import { useSignUpService } from '../../services/signUpService';
import { IUserProperties } from '../../services/signUpService/types';
import loginStyles from '../Login/index.module.scss';
import formStyles from '../Login/LoginContent/index.module.scss';
import BackButton from './BackButton';

function SetUpAccountForm() {
  const {
    state,
    challenge,
    state: { errorMessage, isSetUpAccountState, signUpFlowState, isLoading },
  } = useSignUpService();
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
  });

  const onSubmit = (formData: Partial<{ name: string; familyName: string }>) => {
    signUpFlowState?.onSignUp?.(formData as IUserProperties);
  };

  return (
    <div
      className={classNames(formStyles.root, loginStyles.boxContainer, 'w-full', {
        [loginStyles.hide]: !isSetUpAccountState || !isEmpty(challenge),
      })}
    >
      <BackButton onClick={() => state.resetSignupFlowState()} />
      <span className={loginStyles.title}>Set up your account</span>
      <form onSubmit={handleSubmit(onSubmit)}>
        <TextField
          label={'First name'}
          wrapperClassName={formStyles.inputWrapper}
          error={!!errors?.name}
          helperText={errors?.name?.message}
          inputClassName={formStyles.inputField}
          hideErrorIcon
          variant="outlined"
          InputLabelProps={{
            classes: {
              shrink: formStyles.shrink,
            },
          }}
          {...register('name', {
            required: `Please enter first name`,
          })}
        />
        <TextField
          label={'Last name'}
          wrapperClassName={formStyles.inputWrapper}
          error={!!errors?.familyName}
          helperText={errors?.familyName?.message}
          inputClassName={formStyles.inputField}
          hideErrorIcon
          variant="outlined"
          InputLabelProps={{
            classes: {
              shrink: formStyles.shrink,
            },
          }}
          {...register('familyName', {
            required: `Please enter last name`,
          })}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={!isValid}
          className={clsx(formStyles.submitBtn, 'rounded-4')}
        >
          {isLoading ? <CircularProgress size={15} /> : 'Create account'}
        </Button>
        {errorMessage ? <div className={formStyles.error}>{errorMessage}</div> : null}
      </form>
    </div>
  );
}
export default observer(SetUpAccountForm);
